import React, { useMemo, useState } from "react";
import { Consult } from "../../components/Consult";
import {
  consultarOpcoes,
  noticiasOpcoes,
  rangePresets,
} from "../../constants/constants";
import dayjs from "dayjs";
import locale from "antd/es/date-picker/locale/pt_BR";
import { Button, DatePicker, Input, Radio, Select } from "antd";
import { request } from "../../functions/request";
import { Content } from "antd/es/layout/layout";
import { AiFillEdit, AiFillEye } from "react-icons/ai";
import { Link } from "react-router-dom";
const { RangePicker } = DatePicker;

export default function ConsultNoticias() {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [data, setData] = useState([]);
  const [modalContent, setModalContent] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const columns = useMemo(
    () => [
      {
        accessorKey: "not_numero",
        header: "ID",
        size: 40,
      },
      {
        accessorKey: "not_titulo",
        header: "Título",
        size: 60,
      },
      {
        accessorKey: "not_lead",
        header: "Lead",
        size: 100,
      },
      {
        accessorKey: "not_data",
        header: "Data",
        size: 60,
      },
      {
        accessorKey: "not_secao",
        header: "Seção",
        size: 60,
        filterVariant: "multi-select",
      },
    ],
    []
  );

  const transformSectionComent = (section) => {
    switch (section) {
      case 1:
        return "Boi";
      case 2:
        return "Frango";
      case 3:
        return "Grãos";
      case 4:
        return "Leite";
      case 5:
        return "Suínos";
      case 8:
        return "Agroações";
      case 9:
        return "Bolsas e Opções";
      default:
        return "Outros";
    }
  };

  const makeQuery = (form) => {
    let queryParams = `data_start=${dayjs(form.data[0]).format(
      "YYYY-MM-DD"
    )}&data_final=${dayjs(form.data[1]).format("YYYY-MM-DD")}`;

    if (form?.palavra) {
      queryParams += `&req_type=${encodeURIComponent(
        form.opcao
      )}&input_query=${encodeURIComponent(form.palavra)}`;
    }
    if (form?.secao) {
      queryParams += `&not_secao=${encodeURIComponent(form.secao)}`;
    }

    return queryParams;
  };

  const fetchData = async (form) => {
    try {
      setHasError(false);
      setIsLoading(true);
      await request(`/noticia/getnoticias?${makeQuery(form)}`, {
        method: "GET",
      })
        .then((response) => {
          const formattedData = response[0].map((res) => {
            res.not_data = dayjs(res?.not_data).format("DD/MM/YYYY HH:mm");
            res.not_secao = transformSectionComent(res?.not_secao);
            return res;
          });
          if (response[0].length <= 0) {
            setData([]);
            setHasError(true);
          } else {
            setData(formattedData);
          }
        })
        .finally(() => {
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setData([]);
          setIsLoading(false);
          setHasError(true);
        });
    } catch (error) {
      console.error("Erro na requisição:", error);
      setData([]);
      setIsLoading(false);
      setHasError(true);
    }
  };

  return (
    <Consult.Root>
      <Consult.Form
        title={"Consultar Notícias"}
        onFinish={(values) => {
          fetchData(values);
        }}
        variant="filled"
        initialValues={{
          secao: false,
          opcao: "busca_completa",
        }}
      >
        <Consult.Field label={"Seção"} name={"secao"}>
          <Select
            showSearch
            style={{ width: "100%" }}
            optionFilterProp="children"
            placeholder="Selecione uma seção"
            defaultValue={{ value: false, label: "Todos" }}
            filterOption={(input, option) =>
              (option?.label ?? "").includes(input)
            }
            options={noticiasOpcoes}
          />
        </Consult.Field>
        <Consult.Field
          label={"Data Inicial e Final"}
          name={"data"}
          hasFeedback
          rules={[
            { required: true, message: "Escolha uma data de início e fim" },
          ]}
        >
          <RangePicker
            style={{ width: "100%" }}
            presets={rangePresets}
            locale={locale}
          />
        </Consult.Field>
        <Consult.Field label={"Palavra-Chave"} name={"palavra"}>
          <Input placeholder="Ex.: BOI GORDO EUA | SOJA EXPORTAÇÃO | MILHO CHICAGO" />
        </Consult.Field>
        <Consult.Field name={"opcao"}>
          <Radio.Group defaultValue="busca_completa" buttonStyle="outline">
            {consultarOpcoes.map((option) => (
              <Radio.Button key={option.value} value={option.value}>
                {option.text}
              </Radio.Button>
            ))}
          </Radio.Group>
        </Consult.Field>
        <Consult.Field>
          <Consult.Button htmlType="submit" title="Buscar" />
        </Consult.Field>
      </Consult.Form>
      <Consult.Table
        data={data}
        columns={columns}
        isLoading={isLoading}
        hasError={hasError}
        initialState={{
          showColumnFilters: true,
          pagination: { pageIndex: 0, pageSize: 100 },
        }}
        renderRowActions={({ row }) => (
          <Content
            style={{
              display: "flex",
              gap: "5px",
              flexWrap: "wrap",
            }}
          >
            <Button
              onClick={() => {
                setModalContent(row.original);
                setIsModalOpen(true);
              }}
              icon={<AiFillEye />}
            >
              Visualizar
            </Button>
            <Link
              to={`/editor-noticia/${row.original.not_numero}`}
              //target="_blank"
            >
              <Button icon={<AiFillEdit />}>Editar</Button>
            </Link>
          </Content>
        )}
      >
        <Consult.Modal
          title={modalContent?.not_titulo}
          date={modalContent?.not_data}
          text={modalContent?.not_texto}
          isOpen={isModalOpen}
          onRequestClose={() => setIsModalOpen(false)}
        />
      </Consult.Table>
    </Consult.Root>
  );
}
